<script setup lang="ts">
import { provide } from 'vue';

import {
    type DialogPortalStackContext,
    dialogPortalStackKey
} from '@/lib/dialogPortalStack';

const stack: DialogPortalStackContext = {
    portalZIndexClass: 'z-[70]'
};

provide(dialogPortalStackKey, stack);
</script>

<template>
    <slot />
</template>
